import { Controller } from "@hotwired/stimulus"

// Polls the batch progress endpoint and updates the progress bar. Reloads the
// page when synthesis finishes, and surfaces a retry if it appears stalled.
export default class extends Controller {
  static targets = ["bar", "label", "failed", "error", "stalled"]
  static values = {
    url: String,
    interval: { type: Number, default: 1500 },
    stallMs: { type: Number, default: 60000 }
  }

  connect() {
    this.tick = this.tick.bind(this)
    this.lastProcessed = -1
    this.lastChange = Date.now()
    this.timer = setInterval(this.tick, this.intervalValue)
    this.tick()
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async tick() {
    let data
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!response.ok) return
      data = await response.json()
    } catch (_error) {
      return // transient network error — keep polling
    }

    const total = Number(data.total) || 0
    const done = Number(data.done) || 0
    const failed = Number(data.failed) || 0
    const processed = done + failed

    if (this.hasLabelTarget) this.labelTarget.textContent = `${processed} / ${total}`
    if (this.hasBarTarget) this.barTarget.style.width = total ? `${Math.round((100 * processed) / total)}%` : "0%"
    if (this.hasFailedTarget) {
      this.failedTarget.textContent = `(błędy: ${failed})`
      this.failedTarget.classList.toggle("hidden", failed === 0)
    }

    // Stall detection: if the processed count hasn't moved for a while, offer a retry.
    if (processed !== this.lastProcessed) {
      this.lastProcessed = processed
      this.lastChange = Date.now()
      if (this.hasStalledTarget) this.stalledTarget.classList.add("hidden")
    } else if (Date.now() - this.lastChange > this.stallMsValue) {
      if (this.hasStalledTarget) this.stalledTarget.classList.remove("hidden")
    }

    if (data.status === "done") {
      clearInterval(this.timer)
      window.location.reload()
    } else if (data.status === "error") {
      clearInterval(this.timer)
      if (this.hasErrorTarget) {
        this.errorTarget.textContent = data.error || "Coś poszło nie tak podczas generowania audio."
        this.errorTarget.classList.remove("hidden")
      }
    }
  }
}
